import type { FaireProductEntity } from "../../entity_types/product";

export const p_km8azg873p: FaireProductEntity = {
  token: "p_km8azg873p",
  type: "product",
  name: "Puka Shell Choker\u00a0",
  brandName: "Salty But Sweet",
  imageUrl:
    "https://cdn.faire.com/fastly/256eda86a03b3f7b8cd05ca4b091470331b102a0c03f6b68d562c2658893d07f.jpeg",
  priceDollars: 18,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/ea1637126b5d5ec8bedf3025ae1617817e50b3281d8c8e2ef557fc783b8ba82c.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
